/*
 * This file is auto-generated. Do not modify it manually!
 * Run 'yarn workspace @proton/icons build' to update the icons react components.
 */
import React from 'react';

import type { IconSize } from '../types';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    /** If specified, renders an sr-only element for screenreaders */
    alt?: string;
    /** If specified, renders an inline title element */
    title?: string;
    /**
     * The size of the icon
     * Refer to the sizing taxonomy: https://design-system.protontech.ch/?path=/docs/components-icon--basic#sizing
     */
    size?: IconSize;
}

export const IcVault = ({ alt, title, size = 4, className = '', viewBox = '0 0 16 16', ...rest }: IconProps) => {
    return (
        <>
            <svg
                viewBox={viewBox}
                className={`icon-size-${size} ${className}`}
                role="img"
                focusable="false"
                aria-hidden="true"
                {...rest}
            >
                {title ? <title>{title}</title> : null}

                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8ZM9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.58579 3.58579C3 4.17157 3 5.11438 3 7V9C3 10.8856 3 11.8284 3.58579 12.4142C4.17157 13 5.11438 13 7 13H9C10.8856 13 11.8284 13 12.4142 12.4142C13 11.8284 13 10.8856 13 9V7C13 5.11438 13 4.17157 12.4142 3.58579C11.8284 3 10.8856 3 9 3H7C5.11438 3 4.17157 3 3.58579 3.58579ZM9 4H7C6.02892 4 5.40121 4.00212 4.9387 4.06431C4.50496 4.12262 4.36902 4.21677 4.29289 4.29289C4.21677 4.36902 4.12262 4.50496 4.06431 4.9387C4.00212 5.40121 4 6.02892 4 7V9C4 9.97108 4.00212 10.5988 4.06431 11.0613C4.12262 11.495 4.21677 11.631 4.29289 11.7071C4.36902 11.7832 4.50496 11.8774 4.9387 11.9357C5.40121 11.9979 6.02892 12 7 12H9C9.97108 12 10.5988 11.9979 11.0613 11.9357C11.495 11.8774 11.631 11.7832 11.7071 11.7071C11.7832 11.631 11.8774 11.495 11.9357 11.0613C11.9979 10.5988 12 9.97108 12 9V7C12 6.02892 11.9979 5.40121 11.9357 4.9387C11.8774 4.50496 11.7832 4.36902 11.7071 4.29289C11.631 4.21677 11.495 4.12262 11.0613 4.06431C10.5988 4.00212 9.97108 4 9 4Z"
                ></path>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.17157 1.17157C0 2.34315 0 4.22876 0 8C0 11.7712 0 13.6569 1.17157 14.8284C2.34315 16 4.22876 16 8 16C11.7712 16 13.6569 16 14.8284 14.8284C16 13.6569 16 11.7712 16 8C16 4.22876 16 2.34315 14.8284 1.17157C13.6569 0 11.7712 0 8 0C4.22876 0 2.34315 0 1.17157 1.17157ZM3.74416 14.8625C4.75129 14.9979 6.08611 15 8 15C9.91389 15 11.2487 14.9979 12.2558 14.8625C13.2342 14.7309 13.7523 14.4903 14.1213 14.1213C14.4903 13.7523 14.7309 13.2342 14.8625 12.2558C14.9979 11.2487 15 9.91389 15 8C15 6.08611 14.9979 4.75129 14.8625 3.74416C14.7309 2.76579 14.4903 2.2477 14.1213 1.87868C13.7523 1.50966 13.2342 1.26907 12.2558 1.13753C11.2487 1.00212 9.91389 1 8 1C6.08611 1 4.75129 1.00212 3.74416 1.13753C2.76579 1.26907 2.2477 1.50966 1.87868 1.87868C1.50966 2.2477 1.26907 2.76579 1.13753 3.74416C1.00212 4.75129 1 6.08611 1 8C1 9.91389 1.00212 11.2487 1.13753 12.2558C1.26907 13.2342 1.50966 13.7523 1.87868 14.1213C2.2477 14.4903 2.76579 14.7309 3.74416 14.8625Z"
                ></path>
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
